import PropTypes from 'prop-types';
import { pulse } from 'react-animations';
import React from 'react';
import styled, { keyframes } from 'react-emotion';

import { Paragraph } from '../Text/Text';

const pulseAnimation = keyframes`${pulse}`;

const Message = styled(Paragraph)`
  animation: 2s ${pulseAnimation} infinite;
`;

function LoadingText(props) {
  return (
    <Message
      className={props.className} // To enable extending styles using Emotion https://emotion.sh/docs/styled#styling-any-component
    >
      {props.children}
    </Message>
  );
}

LoadingText.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
};

LoadingText.defaultProps = {
  className: '',
};

export default LoadingText;



// WEBPACK FOOTER //
// ./src/components/LoadingText/LoadingText.js